import React, { useReducer } from 'react'
import UserContext from './userContext'
import UserReducer from './userReducer'
import { apiCallSeller } from '../../../common/api'
import { response } from '../../common'

import {
    GET_ALL_USERS,
    GET_SINGLE_USER,
    GET_DASHBOARD_USER,
    GET_ALL_BIDDING_USERS,
    CLEAR_RESPONSE,
    RESPONSE_STATUS,
} from './userTypes'

const UserState = (props) => {
    const initialState = {
        responseStatus: null,
        single_user: {
            record: {},
        },
        search_alldashboardproducts: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            sorts: {},
        },
        all_users: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        all_bidding_users: {
            records: [],
        },
    }

    const [state, dispatch] = useReducer(UserReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllUsers = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCallSeller('post', 'allbuyers', formData, '', 'user'),
            ])
            const from = 'UserManagement'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_USERS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllBiddingUsers = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCallSeller('post', 'allbiddingbuyers', formData, '', 'user'),
            ])
            const from = 'UserManagement'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_BIDDING_USERS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSingleUser = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCallSeller('post', 'getSingleUser', formData, '', 'user'),
            ])
            const from = 'UserManagement'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_USER,
                    payload: {
                        record: res.data.data.responseData.record
                            ? res.data.data.responseData.record
                            : {},
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getDashboardUser = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCallSeller('post', 'dashboard', formData, '', 'user/product'),
            ])
            const from = 'UserManagement'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_DASHBOARD_USER,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const userAction = async (formData) => {
        try {
            const from = 'userAction'
            const [res] = await Promise.all([
                apiCallSeller('post', 'userAction', formData, '', 'user'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const changeUserStatus = async (formData) => {
        try {
            const from = 'changeStatus'
            const [res] = await Promise.all([
                apiCallSeller('post', 'changeStatus', formData, '', 'user'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const triggerEmail = async (formData) => {
        try {
            const from = 'triggerEmail'
            const [res] = await Promise.all([
                apiCallSeller('post', 'triggerEmail', formData, '', 'user'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const addInviteUser = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCallSeller('post', 'addinviteuser', formData, '', 'user'),
            ])
            resp.commonResponse(res.data, 'addInviteUser')
        } catch (err) {
            resp.commonErrorResponse('addInviteUser')
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })
    return (
        <UserContext.Provider
            value={{
                all_users: state.all_users,
                all_bidding_users: state.all_bidding_users,
                single_user: state.single_user,
                responseStatus: state.responseStatus,
                search_alldashboardproducts: state.search_alldashboardproducts,
                getDashboardUser,
                clearResponse,
                getAllUsers,
                getAllBiddingUsers,
                triggerEmail,
                getSingleUser,
                userAction,
                changeUserStatus,
                addInviteUser,
            }}
        >
            {props.children}
        </UserContext.Provider>
    )
}

export default UserState
